<template>

    <AppHead title="Admin" />

    <div class="pt-24">
        <div class="space-y-8">
            <h1 class="text-3xl">Accounts</h1>
            <div class="">
                <LineChart class="h-80" v-bind="lineChartProps" />
            </div>
            <div class="grid grid-cols-2 mb-12">
                <div class="">
                    <div class="">
                        Accounts total
                    </div>
                    <div class="text-4xl">
                        {{ aggregates.accounts }}
                    </div>
                </div>
                <div class="">
                    <div class="">
                        Userst total
                    </div>
                    <div class="text-4xl">
                        {{ aggregates.users }}
                    </div>
                </div>
            </div>
            <div v-for="account in accounts" class="w-full">
                <div class="font-bold">
                    {{ account.name}}
                </div>
                <div v-for="user in account.users" class="flex w-full space-x-4">
                    <div class="">
                        {{ user.name }}
                    </div>
                    <div class="">
                        {{ user.email }}
                    </div>
                </div>
            </div>
        </div>

        <h1 class="text-3xl mt-24">Roles and Permissions</h1>

        <form @submit.prevent="form.post('/admin/')">
            <!-- <label>
                Roles
                <input type="text" v-model="form.name">
            </label>
            <div v-if="form.errors.name">{{ form.errors.name }}</div> -->


            <div class="px-4">
                <div v-for="(role, roleIndex) in roles" class="grid grid-cols-2 py-6">
                    <div class="">
                        {{ role.name }}
                    </div>
                    <div class="">
                        <label v-for="(permission, permissionIndex) in role.permissions" class="block">
                            <input type="checkbox" v-model="form.roles[roleIndex].permissions[permissionIndex].checked" class="">
                            {{ permission.name }}
                        </label>
                    </div>
                </div>
            </div>

            <button type="submit">
                <Button label="Update" :disabled="form.processing" />
            </button>
        </form>

        <h1 class="text-3xl mt-24">Plans</h1>
        <form @submit.prevent="planForm.post('/admin/')" class="space-y-4">
            <!-- <label>
                Roles
                <input type="text" v-model="form.name">
            </label>
            <div v-if="form.errors.name">{{ form.errors.name }}</div> -->

            <label v-for="(plan, planIndex) in plans" class="block">
                <span>Name (ID: {{planForm.plans[planIndex].id}})</span>
                <input type="text" v-model="planForm.plans[planIndex].name">
            </label>

            <button type="submit">
                <Button label="Update" :disabled="form.processing" />
            </button>
        </form>
    </div>
</template>

<script>
    import Layout from '@/Shared/Layout'
    import { useForm } from '@inertiajs/inertia-vue3'
    import Button from '@/Shared/Button'
    import { LineChart, useLineChart } from 'vue-chart-3'
    import { Chart, registerables } from 'chart.js'
    import { ref, computed } from 'vue'

    Chart.register(...registerables)

    export default {
        setup (props) {
            const form = useForm({
                roles: props.roles,
            })

            const planForm = useForm({
                plans: props.plans
            })

            const chartData = computed(() => ({
                labels: props.userGrowth.labels,
                datasets: [
                    {
                        label: 'Users',
                        data:  props.userGrowth.data,
                        fill: false,
                        borderColor: '#433edb',
                        borderCapStyle: 'round',
                        tension: 0.2,
                        pointRadius: 8,
                        borderJoinStyle: 'round',
                        borderWidth: 2.5,
                        // cubicInterpolationMode: 'monotone',
                        pointBorderColor: 'rgba(0, 0, 0, 0)',
                        pointBackgroundColor: 'rgba(0,0,0,0)',
                        yAxisID: 'y',
                        borderDash: [5,10],
                    },
                    {
                        label: 'Minutes listened',
                        data:  props.minutesListened.data,
                        fill: false,
                        borderColor: '#433edb',
                        borderCapStyle: 'round',
                        tension: 0.2,
                        pointRadius: 8,
                        borderJoinStyle: 'round',
                        borderWidth: 2.5,
                        // cubicInterpolationMode: 'monotone',
                        pointBorderColor: 'rgba(0, 0, 0, 0)',
                        pointBackgroundColor: 'rgba(0,0,0,0)',
                        yAxisID: 'y1',
                    },
                ],
            }))

            const options = {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: '#b1b2b5',
                            font: {
                                family: 'Inter, system-ui, sans-serif',
                                size: 14,
                            },
                            autoSkip: true,
                            maxRotation: 0,
                            maxTicksLimit: 5
                        },
                    },
                    y: {
                        grid: {
                            display: false
                        },
                        position: 'left',
                        ticks: {
                            color: '#b1b2b5',
                            font: {
                                family: 'Inter, system-ui, sans-serif',
                                size: 14,
                            },
                            stepSize: 1,
                            maxTicksLimit: 10,
                            autoSkip: true,
                        },
                    },
                    y1: {
                        grid: {
                            display: false
                        },
                        position: 'right',
                        ticks: {
                            color: '#b1b2b5',
                            font: {
                                family: 'Inter, system-ui, sans-serif',
                                size: 14,
                            },
                            stepSize: 1,
                            maxTicksLimit: 10,
                            autoSkip: true,
                        },
                    }

                },
            }

            const { lineChartProps, lineChartRef } = useLineChart({
                chartData: chartData,
                options: options,
            })

            return { form, lineChartProps, lineChartRef, chartData, planForm }
        },
        components: { Button, LineChart },
        props: {
            roles: Object,
            aggregates: Object,
            accounts: Object,
            userGrowth: Object,
            minutesListened: Object,
            plans: Object,
        },
        layout: Layout,
    }
</script>
